// The tax should be default (and mandatory) 11,11% for students - code  '01'
export const STUDENT_DEFAULT_TAX_CODE = '01'

// The tax should be default 23% for non-students - code '01.1'
export const NONE_STUDENT_DEFAULT_TAX_CODE = '01.1'
